export default __webpack_public_path__ + "static/media/272.139fd174.jpg";